module.exports = __webpack_public_path__ + "static/media/paint_test_picture.a14e5a8a.png";